import * as actions from './actions';
import update from 'react/lib/update';
import { crewRates } from './constants'

export const initState = {
    customPricelists: [],
    selected: 'johnmogensen',
    mode: null,
    createLoading: false,
    deleteLoading: false,
    loadingCustomPricelists: true,
    loadingProductDiscounts: false,
    loadingOffers: false,
    loadingCrewRates: false,
    newName: '',
    offersKey: Math.random(),
    offers: [
    ],
    suggestions: [
    ],
    productDiscounts: [],
    productDiscountsBeforeEdit: [],
    iconKey: Math.random(),
    crewRates: JSON.parse(JSON.stringify(crewRates)),
    crewRatesKey: Math.random(),
}

export default (state = initState, action) => {
    switch (action.type) {
        case 'BLINK':
            return update(state, {
                iconKey: {
                    $set: Math.random(),
                }
            })
        case actions.GET_CUSTOM_PRICELISTS_SUCCESS:
            return update(state, {
                customPricelists: {
                    $set: action.customPricelists
                }
            });
        case actions.MARK_PRICELIST_SELECTED:
            return update(state, {
                selected: {
                    $set: action.index
                }
            });
        case actions.CREATE_NEW_MODE:
            return update(state, {
                mode: {
                    $set: 'create'
                },
                newName: {
                    $set: '',
                },
                offersKey: {
                    $set: Math.random()
                },
                offers: {
                    $set: []
                },
                productDiscounts: {
                    $set: []
                },
                productDiscountsBeforeEdit: {
                    $set: [],
                },
                selected: {
                    $set: 'johnmogensen'
                }
            });
        case actions.EDIT_MODE:
            return update(state, {
                mode: {
                    $set: 'edit'
                },
                productDiscountsBeforeEdit: {
                    $set: state.productDiscounts,
                }
            });
        case actions.COPY_MODE:
            return update(state, {
                mode: {
                    $set: 'create'
                }
            });
        case actions.CANCEL_CREATE_MODE:
            return update(state, {
                mode: {
                    $set: ''
                },
                offersKey: {
                    $set: Math.random()
                },
                productDiscountsBeforeEdit: {
                    $set: [],
                },
            });
        case actions.DELETE_CUSTOM_PRICELIST_MODE:
            return update(state, {
                mode: {
                    $set: 'delete'
                }
            });
        case actions.CREATE_REQUEST_LOADING:
            return update(state, {
                createLoading: {
                    $set: action.status,
                }
            })

        case actions.GET_CUSTOM_PRICELISTS:
            return update(state, {
                loadingCustomPricelists: {
                    $set: true,
                }
            })
        case actions.SET_CUSTOMPRICELISTS_LOADING:
            return update(state, {
                loadingCustomPricelists: {
                    $set: action.status,
                }
            })
        case actions.SET_PRODUCTDISCOUNTS_LOADING:
            return update(state, {
                loadingProductDiscounts: {
                    $set: action.status,
                }
            })
        case actions.SET_OFFERS_LOADING:
            return update(state, {
                loadingOffers: {
                    $set: action.status,
                }
            })
        case actions.DELETE_REQUEST_LOADING:
            return update(state, {
                deleteLoading: {
                    $set: action.status
                }
            })
        case actions.ONCHANGE_NEW_PRICELIST_NAME:
            return update(state, {
                newName: {
                    $set: action.name
                }
            })
        case actions.ADD_CUSTOM_PRICELIST:
            return update(state, {
                customPricelists: {
                    $splice: [[0, 0, { customPricelistId: action.id, name: action.name }]]
                }
            })
        case actions.EDIT_CUSTOM_PRICELIST_NAME:
            return update(state, {
                customPricelists: {
                    [action.index]: {
                        name: {
                            $set: action.name
                        }
                    }
                }
            })
        case actions.REMOVE_CUSTOM_PRICE_LIST:
            return update(state, {
                customPricelists: {
                    $splice: [[action.index, 1]]
                }
            })
        case actions.UPDATE_OFFERS:
            return update(state, {
                offers: {
                    $set: action.offers
                },
                offersKey: {
                    $set: Math.random(),
                }
            })
        case actions.PUSH_OFFERS:
            return update(state, {
                offers: {
                    $push: action.offers
                },
                offersKey: {
                    $set: Math.random(),
                }
            })
        case actions.PRODUCT_SUGGESTIONS_SUCCESS:
            return update(state, {
                suggestions: {
                    $set: action.suggestions
                }
            })
        case actions.SET_DISCOUNT_LIST:
            return update(state, {
                productDiscounts: {
                    $set: action.discounts
                }
            })
        case actions.ADD_PRODUCT_TO_DISCOUNT_LIST:
            return update(state, {
                productDiscounts: {
                    $splice: [[0, 0, action.product]]
                }
            })
        case actions.UPDATE_DISCOUNT_PRICE:
            return update(state, {
                productDiscounts: {
                    [action.index]: {
                        discount: {
                            $set: action.val
                        }
                    }
                }
            })
        case actions.REMOVE_DISCOUNT_PRICE:
            return update(state, {
                productDiscounts: {
                    $splice: [[action.index, 1]]
                }
            })
        case actions.REMOVE_ALL_DISCOUNTS:
            return update(state, {
                productDiscounts: {
                    $set: []
                }
            })
        case actions.UPDATE_EMPLOYEE_FUNCTION_ROW:
            return update(state, {
                crewRates: {
                    [action.fun]: {
                        $set: action.object
                    }
                },
                crewRatesKey: {
                    $set: Math.random()
                },
            })
        case actions.SET_CREWRATES:
            return update(state, {
                crewRates: {
                    $set: action.crewRates
                },
                crewRatesKey: {
                    $set: Math.random()
                },
            })
        case actions.SET_CREWRATES_LOADING:
            return update(state, {
                loadingCrewRates: {
                    $set: action.status,
                }
            })
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/App/CustomPricelist/reducer.js